import React from "react";
import { AnalyticLayoutContainer } from "./Layout.style";

export const AnalyticLayout: React.FC = ({ children }) => (
  <AnalyticLayoutContainer>
    {children}
  </AnalyticLayoutContainer>
)
